var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"size":"small","placeholder":"可多选","multiple":"","value":_vm.value},on:{"change":_vm.handleChange}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }